import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/api";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0B] text-[#F4F4F6] flex items-center justify-center px-4" data-testid="admin-login-page">
      <motion.form onSubmit={submit} initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}
        className="w-full max-w-sm border border-white/10 bg-[#121214] p-8 flex flex-col gap-5">
        <h1 className="font-display uppercase text-4xl tracking-wider">Admin</h1>
        <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email"
          data-testid="admin-login-email"
          className="bg-transparent border border-white/15 px-4 py-3 text-sm outline-none focus:border-white transition-colors" />
        <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Senha"
          data-testid="admin-login-password"
          className="bg-transparent border border-white/15 px-4 py-3 text-sm outline-none focus:border-white transition-colors" />
        {error && <p className="text-[#E63946] text-sm" data-testid="admin-login-error">{error}</p>}
        <button type="submit" disabled={loading} data-testid="admin-login-submit"
          className="bg-white text-black font-mono2 text-[11px] tracking-[0.25em] uppercase py-4 hover:bg-[#E63946] hover:text-white transition-colors disabled:opacity-50">
          {loading ? "…" : "Entrar"}
        </button>
        <Link to="/" data-testid="admin-login-back" className="font-mono2 text-[10px] tracking-[0.25em] uppercase text-zinc-500 hover:text-white transition-colors text-center">
          ← Voltar ao site
        </Link>
      </motion.form>
    </div>
  );
}
